import { render, staticRenderFns } from "./ProductPopSearch.vue?vue&type=template&id=da2334ce&"
import script from "./ProductPopSearch.vue?vue&type=script&lang=ts&"
export * from "./ProductPopSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports